export default __webpack_public_path__ + "static/Mercedes W124 E-class-5fbed4c6cf180f51f52a165eb59352ad.jpg";